import {get, post, postJson, imagePost, put,postBlob} from './axios'


//获取当前登录账号信息
export const querySellerSetting = p => get(`tbPhoneBinding/accountSetting`, p);

// 获取验证码
export const getSellerCheckCode = p => get(`tbPhoneBinding/checkCode`, p);

//导出短信记录-精准营销
export const setMessageGf = p => postBlob(`/precisionMarketing/export`, p);

//导出短信记录-精准营销
export const setMessageJz = p => postBlob(`/intelligent-marketing/api/sms-record/export`, p);

//导出短信记录-默认查询
export const setMessageft = p => postBlob(`/sms/send-batch/export`, p);

//导出短信账单-
export const getMessage_Zhangdang = p => postBlob(`/smsRecordStatistics/export`, p);